// What the signed-in user may see — tools and sub-features from Roles & Access (/api/access/me).
import { useEffect, useState } from "react";
import axios from "axios";
import { useAuth } from "./AuthContext";

let cache = { userId: null, data: null, promise: null };

export function invalidateAccess() {
  cache = { userId: null, data: null, promise: null };
}

export function useAccess() {
  const { user } = useAuth();
  const userId = user?.id || null;
  const [data, setData] = useState(cache.userId === userId ? cache.data : null);

  useEffect(() => {
    if (!userId) return undefined;
    let cancelled = false;
    if (cache.userId !== userId || (!cache.data && !cache.promise)) {
      cache = {
        userId,
        data: null,
        promise: axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/access/me`).then((r) => {
          cache.data = r.data;
          return r.data;
        }).catch(() => {
          cache.data = { tools: [], features: {}, failed: true };
          return cache.data;
        }),
      };
    }
    if (cache.data) setData(cache.data);
    else cache.promise.then((d) => { if (!cancelled) setData(d); });
    return () => { cancelled = true; };
  }, [userId]);

  const loading = !data;
  const toolState = (key) => data?.tools?.find((t) => t.key === key)?.state;
  // Unknown keys (or a failed fetch) fall back to allowed so nobody is locked out by a blip.
  const can = (key) => {
    if (!data || data.failed) return true;
    if (key.includes(".")) return data.features?.[key] === "on";
    return toolState(key) === "on";
  };
  return { loading, access: data, can, toolState };
}
